module.exports = __webpack_public_path__ + "static/media/galPic5.20ceb964.JPG";